import { memo, type FC } from "react";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { AppForm } from "@/shared/Components";
import { useEditorForm } from "@/features/NoteEditor/model";
import type { NoteEditorProps } from "@/features/NoteEditor/model/types";
import { PersonSelect } from "../../PersonSelect";
import { DirectionSelect } from "../../DirectionSelect";
import { DateSelect } from "../../DateSelect";
import { DueDateSelect } from "../../DueDateSelect";
import { TypeSelect } from "../../TypeSelect";
import { StatusSelect } from "../../StatusSelect";
import { ImportantFlag } from "../../ImportantFlag";
import { TitleInput } from "../../TitleInput";
import { TextInput } from "../../TextInput";
import { Files } from "../../Files";
import styles from "./styles.module.scss";

export const NoteEditorDesktop: FC<NoteEditorProps> = memo(
  ({ onSubmit, currentNote, onFileDelete }) => {
    const { formApi, noteType } = useEditorForm(currentNote, onSubmit);

    return (
      <div className={styles.root}>
        <AppForm formApi={formApi} onSubmit={() => ""}>
          <div className={styles.header}>
            <div className={styles["header-row"]}>
              {noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT && <DirectionSelect />}
              <div className={styles["header-row-bottom"]}>
                <DateSelect />
                {noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT && <DueDateSelect />}
              </div>
            </div>
            <div className={styles["header-row"]}>
              <PersonSelect />
              <div className={styles["header-row-bottom"]}>
                <TypeSelect />
                {(noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT ||
                  noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_IDEA) && <StatusSelect />}
              </div>
            </div>
          </div>
          <div className={styles.body}>
            <div className={styles.title}>
              <ImportantFlag />
              <TitleInput />
            </div>
            <div className={styles.files}>
              {currentNote.personId && currentNote?.text && (
                <Files onFileDelete={onFileDelete} mobile={false} />
              )}
            </div>
            <div className={styles.text}>
              <TextInput />
            </div>
          </div>
        </AppForm>
      </div>
    );
  },
);
